import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { errorMessage, errorMessageHandler } from 'src/app/core/utils/error-handler.utils';
import { DatosFormularioFactura } from 'src/app/models/carga-fc.dto';
import { ComprobanteDto } from 'src/app/models/comp.dto';
import { CondicionVentaDto } from 'src/app/models/condi-fiscal.dto';
import { MonedasDto } from 'src/app/models/monedas.dto';
import { ProveedorDto } from 'src/app/models/proveedores.dto';
import { ProvinciasDto } from 'src/app/models/provincias.dto';
import { CompService } from 'src/app/services/comp.service';
import { CondiVentaService } from 'src/app/services/condi-venta.service';
import { ConfigGeneralService } from 'src/app/services/config-general.service';
import { MonedasService } from 'src/app/services/monedas.service';
import { ProveedoresService } from 'src/app/services/proveedores.service';
import { ProvinciasService } from 'src/app/services/provincias.service';
import { ComproCabeProveService } from 'src/app/services/compro-cabe-prove.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { showMatSnackMessage } from 'src/app/core/utils/message-handler.util';

@Component({
  selector: 'app-datos-facturas-proveedor',
  templateUrl: './datos-facturas-proveedor.component.html',
  styleUrls: ['./datos-facturas-proveedor.component.scss'],
})
export class DatosFacturasProveedorComponent {
  comps: ComprobanteDto[] = [];
  provincias: ProvinciasDto[] = [];
  monedas: MonedasDto[] = [];
  condiVentas: CondicionVentaDto[] = [];

  @Input() formulario!: DatosFormularioFactura;

  @ViewChild('tipoInput') tipoInput!: ElementRef<HTMLSelectElement>;
  @ViewChild('numeroInput') numeroInput!: ElementRef<HTMLInputElement>;
  @ViewChild('sucursalInput') sucursalInput!: ElementRef<HTMLInputElement>;
  @ViewChild('remitoInput') remitoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('provinciaSelect') provinciaSelect!: ElementRef<HTMLInputElement>;
  @ViewChild('fechaEmisionInput') fechaEmisionInput!: ElementRef<HTMLInputElement>;
  @ViewChild('fechaVencimientoInput') fechaVencimientoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('fechaPagoInput') fechaPagoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('fechaRegistroInput') fechaRegistroInput!: ElementRef<HTMLInputElement>;
  @ViewChild('fechaPresentacionInput') fechaPresentacionInput!: ElementRef<HTMLInputElement>;

  constructor(
    private comproCabeProveService: ComproCabeProveService,
    private compService: CompService,
    private provinciasService: ProvinciasService,
    private monedasService: MonedasService,
    private condiVentaService: CondiVentaService,
    private proveedoresService: ProveedoresService,
    private configGeneralService: ConfigGeneralService,
    private snackBar: MatSnackBar
  ) { }


  ngOnInit(): void {
    this.cargarSelects();
    this.completarDatosProveedor();
    this.consultarTamanoPermitido();
    this.formulario.archivo.limiteSubida = 5;
  }

  ngAfterViewInit() {
    setTimeout(() => {

      if (this.formulario.datosBasicos.moneda)
        this.onCurrencyChange(this.formulario.datosBasicos.moneda);

    }, 1000);
  }

  cargarSelects(): void {
    this.compService.getAll().subscribe(data => this.comps = data);
    this.provinciasService.getAll().subscribe(data => this.provincias = data);
    this.monedasService.getAll().subscribe(data => this.monedas = data);
    this.condiVentaService.getAll().subscribe(data => this.condiVentas = data);
  }

  consultarTamanoPermitido() {
    this.configGeneralService.getByConfig('CONLINE_ARCHIVO_TAMANO_PERMITIDO')
      .subscribe(data => {

        if (data && data[0].VALOR_CONFIG) {

          try {
            this.formulario.archivo.limiteSubida = Number(data[0].VALOR_CONFIG);
          } catch (error) {
            this.formulario.archivo.limiteSubida = 5;
          }

        }

      });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      let limiteSubida = 5;

      if (this.formulario.archivo.limiteSubida)
        limiteSubida = this.formulario.archivo.limiteSubida;

      const maxSize = limiteSubida * 1024 * 1024; // 5 MB | config
      const allowedTypes = ['application/pdf'];

      if (!allowedTypes.includes(file.type)) {
        errorMessage('Solo se permiten archivos PDF, imágenes o Excel.');
        this.eliminarArchivo();
        return;
      }

      if (file.size > maxSize) {
        errorMessage(`El archivo no debe superar los ${limiteSubida} MB.`);
        this.eliminarArchivo();
        return;
      }

      this.formulario.archivo.binario = file;
      this.formulario.archivo.nombre = file.name;
    } else {
      this.eliminarArchivo();
    }
  }

  eliminarArchivo(): void {
    this.formulario.archivo.nombre = '';
    this.formulario.archivo.binario = null;

    const fileInput = document.getElementById('invoice-file') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }

  onCurrencyChange(event: any): void {
    const monedaSeleccionada = this.monedas.find(m => m.mone === event);

    if (monedaSeleccionada) {
      this.formulario.datosBasicos.cotizacion = monedaSeleccionada.mone_coti;
    }
  }

  completarDatosProveedor() {

    this.proveedoresService.getProveedor().subscribe({
      next: (response: ProveedorDto) => {
        this.procesarResponsecompletarDatosProveedor(response);
      },
      error: (error: any) => {
        errorMessageHandler(error);
      },
      complete: () => {
      },
    });

  }

  procesarResponsecompletarDatosProveedor(response: ProveedorDto) {

    if (!this.formulario) return;

    if (response.PROVINCIA)
      this.formulario.datosBasicos.provincia = response.PROVINCIA;

    if (response.CONDI_PAGO)
      this.formulario.datosBasicos.condicionPago = response.CONDI_PAGO;

  }

  onCompChange(event: any): void {
    let compGeneraAsiento = 'N';

    const compSeleccionado = this.comps.find(c => c.COD_COMP === event);

    if (compSeleccionado)
      compGeneraAsiento = compSeleccionado.ASIEN_GENE;

    this.formulario.datosBasicos.compGeneraAsiento = compGeneraAsiento;
  }

  proponerNumeracion() {

    if (!this.formulario.datosBasicos.tipo) {
      showMatSnackMessage(this.snackBar, 'Debe seleccionar comprobante para poner numeración', 5000, 'snackbar-custom-orange');
      return;
    }

    this.comproCabeProveService.proponerNumeracion(this.formulario.datosBasicos.tipo).subscribe({
      next: (response: [{ num: number }]) => {

        this.formulario.datosBasicos.numero = 0;

        if (response && response[0].num) {
          this.formulario.datosBasicos.numero = response[0].num + 1;
        } else {
          errorMessage("Sin numeración disponible");
        }

      },
      error: (error: any) => {
        errorMessageHandler(error);
      },
      complete: () => {
      },
    });
  }

  public validarFormulario(): boolean {
    const datos = this.formulario.datosBasicos;
    const fechas = this.formulario.fechas;

    if (!datos.tipo) {
      this.mostrarErrorYEnfocar('Debe seleccionar un tipo de comprobante.', this.tipoInput);
      return false;
    }

    if (!datos.numero) {
      this.mostrarErrorYEnfocar('El campo Número es obligatorio.', this.numeroInput);
      return false;
    }

    if (!datos.sucursal) {
      this.mostrarErrorYEnfocar('El campo Sucursal es obligatorio.', this.sucursalInput);
      return false;
    }

    if (!datos.provincia) {
      this.mostrarErrorYEnfocar('El campo Provincia es obligatorio.', this.provinciaSelect);
      return false;
    }

    if (!fechas.fechaEmision) {
      this.mostrarErrorYEnfocar('El campo Fecha Emisión es obligatorio.', this.fechaEmisionInput);
      return false;
    }

    const fechaEmision = new Date(fechas.fechaEmision);

    if (fechas.fechaVencimiento) {
      const fechaVencimiento = new Date(fechas.fechaVencimiento);
      if (fechaVencimiento < fechaEmision) {
        this.mostrarErrorYEnfocar('La fecha de vencimiento no puede ser anterior a la fecha del comprobante.', this.fechaVencimientoInput);
        return false;
      }
    }

    if (fechas.fechaPago) {
      const fechaPago = new Date(fechas.fechaPago);
      if (fechaPago < fechaEmision) {
        this.mostrarErrorYEnfocar('La fecha de pago no puede ser anterior a la fecha del comprobante.', this.fechaPagoInput);
        return false;
      }
    }

    if (fechas.fechaPresentacion) {
      const fechaPresentacion = new Date(fechas.fechaPresentacion);
      if (fechaPresentacion < fechaEmision) {
        this.mostrarErrorYEnfocar('La fecha de presentación no puede ser anterior a la fecha del comprobante.', this.fechaPresentacionInput);
        return false;
      }
    }

    return true;
  }

  private mostrarErrorYEnfocar(mensaje: string, elemento: ElementRef) {
    showMatSnackMessage(this.snackBar, mensaje, 5000, 'snackbar-custom-orange');
    elemento.nativeElement.focus();
    elemento.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
